import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full pt-4 pb-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative" data-id="element-160">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-161">
        <div className="text-brand-cyan font-bold tracking-widest text-[10px] sm:text-xs mb-4 uppercase flex items-center gap-2" data-id="element-162">
          <span className="text-base" style={{
          fontFamily: 'serif'
        }} data-id="element-163">
            ∞
          </span>
          Infinitamente digital
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-164">
            <path d="M12 2a5 5 0 0 1 4.9 4 4.5 4.5 0 0 1 2.1 3.8 4.5 4.5 0 0 1-1.5 3.4A4 4 0 0 1 16 17h-1v5h-6v-5H8a4 4 0 0 1-1.5-3.8A4.5 4.5 0 0 1 5 9.8 4.5 4.5 0 0 1 7.1 6 5 5 0 0 1 12 2z" data-id="element-165" />
            <path d="M12 2v8" data-id="element-166" />
            <path d="M8 10h8" data-id="element-167" />
          </svg>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight max-w-4xl" data-id="element-168">
          Tu cuenta blindada contra{' '}
          <span className="text-brand-cyan" data-id="element-169">cualquier estafa</span>
        </h1>

        <div className="relative w-full max-w-xl mx-auto mb-2" data-id="element-170">
          {/* Halo de luz detrás del mockup */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(0,212,255,0.25) 0%, rgba(0,212,255,0.08) 35%, transparent 70%)',
          filter: 'blur(30px)',
          transform: 'scale(1.2)'
        }} data-id="element-171" />
          <img src="https://cdn.magicpatterns.com/uploads/3MeRUzvAFKP8EkjXngnumW/af489ce2-f292-44c1-aa54-18493258603c.png" alt="Mega Pack Cuenta Blindada" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl pl-[10px] pr-[10px] mt-[-20px] mb-[-30px] ml-[0px] mr-[0px]" data-id="element-172" />
        </div>

        <p className="text-base sm:text-lg md:text-xl text-white font-medium mb-6 mt-0 max-w-3xl leading-relaxed" data-id="element-173">
          Protegé tu{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-174">WhatsApp</span>, tu{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-175">Home Banking</span> y
          tus{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-176">
            billeteras virtuales
          </span>{' '}
          antes de que alguien más lo haga por vos.
        </p>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-2 text-white font-extrabold text-lg sm:text-xl px-10 py-4 rounded-full hover:scale-105 transition-all duration-200 uppercase tracking-wide" style={{
        background: '#FF9900',
        boxShadow: '0 0 25px rgba(255,153,0,0.4)'
      }} onMouseEnter={e => {
        e.currentTarget.style.background = '#e68a00';
        e.currentTarget.style.boxShadow = '0 0 35px rgba(255,153,0,0.6)';
      }} onMouseLeave={e => {
        e.currentTarget.style.background = '#FF9900';
        e.currentTarget.style.boxShadow = '0 0 25px rgba(255,153,0,0.4)';
      }} data-id="element-177">
          Quiero blindar mis cuentas
        </motion.a>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 text-[10px] sm:text-xs text-gray-400 font-normal" data-id="element-178">
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-179">
            <span className="text-[10px]" data-id="element-180">📄</span> 100% PDF
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-181">
            <span className="text-[10px]" data-id="element-182">⚡</span> Acceso inmediato
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-183">
            <span className="text-[10px]" data-id="element-184">🛡️</span> Garantía 7 días
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-185">
            <span className="text-[10px]" data-id="element-186">💳</span> Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}